import { render } from "./pageFilter.vue?vue&type=template&id=5d780e25&ts=true"
import script from "./pageFilter.vue?vue&type=script&lang=ts"
export * from "./pageFilter.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__